import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed w-full z-50 bg-background text-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-primary">Rueda de la Vida</Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" 
              className={`hover:text-primary transition-colors ${location.pathname === '/' ? 'text-primary' : ''}`}>
              Home
            </Link>
            <Link to="/schedule" 
              className={`hover:text-primary transition-colors ${location.pathname === '/schedule' ? 'text-primary' : ''}`}>
              Schedule
            </Link>
            <Link to="/lessons" 
              className={`hover:text-primary transition-colors ${location.pathname === '/lessons' ? 'text-primary' : ''}`}>
              Lessons
            </Link>
            {/* <Link to="/jobs" 
              className={`hover:text-primary transition-colors ${location.pathname.startsWith('/jobs') ? 'text-primary' : ''}`}>
              Jobs
            </Link> */}
            <Link to="/summer-camp" 
              className={`hover:text-primary transition-colors ${location.pathname === '/summer-camp' ? 'text-primary' : ''}`}>
              Summer Camp
            </Link>      
            <Link to="/free-events" 
              className={`hover:text-primary transition-colors ${location.pathname === '/free-events' ? 'text-primary' : ''}`}>
              Free Events
            </Link>                     
            <Link to="/about" 
              className={`hover:text-primary transition-colors ${location.pathname === '/about' ? 'text-primary' : ''}`}>
              About Us
            </Link>            
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} 
              className="text-white hover:text-primary">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="flex flex-col space-y-4 px-2 pt-2 pb-4">
              <Link to="/" 
                className="hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              <Link to="/schedule" 
                className="hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}>
                Schedule
              </Link>
              <Link to="/lessons" 
                className="hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}>
                Lessons
              </Link>
              <Link to="/jobs" 
                className="hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}>
                Jobs
              </Link>
              <Link to="/about" 
                className="hover:text-primary transition-colors"
                onClick={() => setIsMenuOpen(false)}>
                About Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;